import type { TabsBlockTemplateProps } from './index';

export default function TabsBlockTemplate({ classes, strip, panelId, labelledBy, panel }: TabsBlockTemplateProps) @{
  <div class={classes}>
    <>{strip}</>
    <div class="crown-tabs-content" role="tabpanel" id={panelId()} aria-labelledby={labelledBy()}>
      {panel()}
    </div>
  </div>
}
